import React from 'react'
import { GiHandOk } from "react-icons/gi";
import { MdLocationPin } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import { RiTimerFlashFill } from "react-icons/ri";


const Chooseus = () => {

    return (
        <div id='about' className='container py-5 mx-auto px-4 md:px-8 lg:px-16'>
            <div className='flex flex-col items-center gap-3'>
                <h4 className=" text-2xl font-bold font-medium primary-color text-center">
                    About Us
                </h4>
                <div className=''>Welcome to Fast Drop Taxis – Your Trusted Drop Taxi Service! Fast Drop Taxis is dedicated to making your travel smooth, reliable, and affordable. We specialize in one-way drop taxi services across Tamil Nadu, allowing you to **pay only for the one-way journey** without additional charges for a return trip. </div>
            </div>


            <h4 className=" text-2xl font-bold font-medium primary-color mt-5 text-center">
                How It Works                </h4>
            <div className='grid grid-cols-1 lg:grid-cols-3 mt-5 gap-5'>
                <div className='flex flex-col items-center  gap-5 '>
                    <div className='border border-2 border-dashed border-black rounded-full p-3  '>
                        <MdLocationPin size={85} className='bg-primary-color rounded-full p-2 text-white' />
                    </div>
                    <div className='flex flex-col items-center'>
                        <p className='font-bold text-2xl'>1. Book Your Ride:</p>

                        <span className='text-center mt-2'>Easily book online or give us a call to arrange your one-way drop.
                        </span>
                    </div>
                </div>
                <div className='flex flex-col items-center gap-5 '>
                    <div className='border border-2 border-dashed border-black rounded-full p-3  '>
                        <IoMdCheckmarkCircleOutline size={85} className='bg-primary-color rounded-full p-2 text-white' />
                    </div>
                    <div className='flex flex-col items-center'>
                        <p className='font-bold text-2xl text-center'>2. Confirm Your Trip</p>

                        <span className='text-center mt-2'>Receive instant confirmation for your booking.</span>
                    </div>
                </div>
                <div className='flex flex-col items-center  gap-5'>
                    <div className='border border-2 border-dashed border-black rounded-full p-3  '>
                        <RiTimerFlashFill size={85} className='bg-primary-color rounded-full p-2 text-white' />
                    </div>
                    <div className='flex flex-col items-center'>
                        <p className='font-bold text-2xl'>3. Pay Only for the Ride</p>

                        <span className='text-center mt-2'>With our simple pricing, pay only for the distance you travel.</span>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Chooseus